import React, {useEffect, useMemo, useState} from 'react';
import {CodeSpecNum} from "../../../constant/CodeSpecNum";
import Search from "../../../components/search/Search";
import {removeRentalAsset} from "../../../api/lifecycle/rental/rentalAssetService";
import {handleActiveError, handleActiveToast} from "../../../components/sonner/ToastBasic";
import {useTranslation} from "react-i18next";
import {RENTAL_ASSET_HEADER} from "../../../components/table/header/Headers";
import SearchSection from "../../../components/search/SearchSection";
import {searchWithChildren} from "../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../components/selector/Selector";
import {SearchComboBox} from "../../../components/select/SearchComboBox";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, nonObject, simmsColumnsToJsGridHeaders} from "../../../components/commonmethod/CommonMethod";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../components/js-grid/SimmsJsGrid";
import JsGridExcelGridOpenButton from "../../../components/js-grid/JsGridExcelGridOpenButton";
import {useNavigate} from "react-router-dom";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../components/pageTabs/pageTabsStorage";

const active = [
    {id: true, name: "대여가능"},
    {id: false, name: "대여불가"},
]

const RentalAssetListType = ({data, date, pageInfo, dataHook}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;

    const handleRefresh = async () => {
        await refresh();
    }

    const [header, setHeader] = useState({order: RENTAL_ASSET_HEADER(handleRefresh), exclude: []});
    const [exclude, setExclude] = useState([]);
    const [, setPin] = useState();

    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate}

    useEffect(() => {
        getIndividualSetting().then(r => {
            initHeaderOrders(r, RENTAL_ASSET_HEADER(handleRefresh), setHeader, exclude, setExclude, setPin, 'rental_asset_v2');
        })
    }, [])

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "대여자산 상세"),
            url: `/lifecycle/rentalAsset/${id}`,
        });
    };

    const deleteRentalAsset = async (rows) => {
        if (!rows?.length) {
            handleActiveError({message: t(`notSelected`)});
            return;
        }
        if (!window.confirm(t(`confirmRentalAssetRemove`))) {
            return;
        }
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        await removeRentalAsset({ids}, () => {
            handleActiveToast({message: t(`removed`)});
            refresh();
        });
    }

    const rentalAssetJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'rental_asset'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo}
                    size detail date={searchDate} searchBar={{placeHolder: '자산명, 자산코드'}}>
                <SearchSection>
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'rentalAssetCode', extractObject(saveConditions), value) }
                                 data={saveConditions?.rentalAssetCode}
                                 parentKey={CodeSpecNum.RentalAssetCode} recursive
                                 entity={"code"} title={"대여자산그룹"}/>
                    <SearchComboBox title={"대여가능 상태"} code={active} target={"active"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "active")}
                    />
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={rentalAssetJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {'rental_asset_v2': v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'rental_asset_v2')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="RentalAsset" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteRentalAsset}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        onClick={() => {
                                            if (ctx.selectedCount === 0) {
                                                handleActiveError({message: t(`notSelected`)});
                                                return;
                                            }
                                            void ctx.transferSelected();
                                        }}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/lifecycle/rentalAsset/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default RentalAssetListType;
